module.exports = "<vue-component class=\"tr-page__wrapper\" component=\"SignForm\" v-props=\"currentParams\"></vue-component>"